import * as React from "react";
const SvgTail = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 29 2", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 1H32", stroke: "#191919", strokeOpacity: 0.22 }));
export default SvgTail;
